import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Dynamic from '@base/Dynamic/Dynamic';
import { TEST_PAGE_VIEWED } from '@constants/segment';
import Description from './Description/Description';
import Attachments from './Section/Attachments';
import AttemptSection from './Section/AttemptSection';
import Syllabus from './Section/Syllabus';
import QuizStatusProvider from './Common/QuizStatusProvider';
import useQuizSegmentAnalytics from '../Common/useQuizSegmentAnalytics';

const Modals = Dynamic(() => import('./Modals'));

const TestDetails = () => {
  const { query } = useRouter();
  const segmentAnalytics = useQuizSegmentAnalytics();
  useEffect(() => {
    segmentAnalytics(TEST_PAGE_VIEWED, {
      is_invited: !!query?.referral_code,
      fpu_invite_code: query?.referral_code
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <QuizStatusProvider>
      <Description />
      <AttemptSection />
      <Syllabus />
      <Attachments />
      <Modals />
    </QuizStatusProvider>
  );
};

export default TestDetails;
